import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, CircularProgress, Typography, Button, Alert } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { reviewBooksAPI } from '../services/api';
import { trackEvent } from '../utils/analytics';

const ReviewRedirect = () => {
    const { slug } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [data, setData] = useState(null);

    useEffect(() => {
        const lookup = async () => {
            try {
                const result = await reviewBooksAPI.getBySlug(slug);
                setData(result);
                trackEvent('review_redirect', {
                    book_title: result.title,
                    format: result.format,
                });
                // Redirect to Amazon after a brief delay
                setTimeout(() => {
                    window.location.href = result.reviewUrl;
                }, 1500);
            } catch (err) {
                setError(err.response?.data?.error || 'Review link not found.');
                setLoading(false);
            }
        };
        lookup();
    }, [slug]);

    if (error) {
        return (
            <Container maxWidth="sm" sx={{ minHeight: '50vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>
                <Button href="/review" variant="outlined" color="primary">
                    Back to Review Page
                </Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" sx={{ minHeight: '50vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
            {loading || !data ? (
                <>
                    <CircularProgress sx={{ mb: 3 }} />
                    <Typography variant="h6" color="text.secondary">
                        Looking up your review link...
                    </Typography>
                </>
            ) : (
                <>
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                        Redirecting to Amazon
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
                        Leaving a review for <strong>{data.title}</strong> ({data.format}).
                        You'll be redirected in a moment.
                    </Typography>
                    <Button
                        href={data.reviewUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        color="primary"
                        endIcon={<OpenInNewIcon />}
                        sx={{ fontWeight: 600 }}
                    >
                        Go to Amazon Now
                    </Button>
                </>
            )}
        </Container>
    );
};

export default ReviewRedirect;
